const headers = {
  name: "Customer Outstanding Statement",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by invoice number",
      value: "",
    },
    {
      type: "filter",
      name: "payment",
      placeholder: "Payments",
      value: null,
      allowClear: true,
      showSearch: false,
      filterOption: true,
      options: [
        {
          value: "Cash",
          label: "Cash",
        },
        {
          value: "Debit card",
          label: "Debit card",
        },
        {
          value: "Bank transfer",
          label: "Bank transfer",
        },
        {
          value: "Credit card",
          label: "Credit card",
        },
        {
          value: "Cheque",
          label: "Cheque",
        },
        {
          value: "Online payment",
          label: "Online payment",
        },
      ],
    },
   
    {
      type: "range",
      name: "date",
      placeholder: ["Start Date", "End Date"],
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Customers",
        path: "/app/customers",
      },
      
      {
        name: "Outstanding Statement",
        path: "",
      },
    ],
  },
};

export default headers;
